import { DialogModule } from '@angular/cdk/dialog';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { ColorPickerModule } from 'ngx-color-picker';
import { TileSetTypeSelectModule } from '../tile-set-type-select/tile-set-type-select.module';
import { TileLayoutConfigurationsComponent } from './tile-layout-configurations.component';

@NgModule({
   declarations: [TileLayoutConfigurationsComponent],
   exports: [TileLayoutConfigurationsComponent],
   imports: [
      CommonModule,
      DialogModule,
      FormsModule,
      ColorPickerModule,
      ReactiveFormsModule,
      MatButtonModule,
      MatFormFieldModule,
      MatIconModule,
      MatInputModule,
      TileSetTypeSelectModule,
   ],
})
export class TileLayoutConfigurationsModule {}
